<script setup>
import { ref } from 'vue'
import { CenterModal, DmDropdownMenuItem, Icon, DmButton } from 'dmui_components'

const emit = defineEmits(['delete:report'])

const showDeleteReport = ref(false)

function onDeleteReport() {
	showDeleteReport.value = false
	emit('delete:report')
}
</script>

<template>
	<DmDropdownMenuItem id="delete-report-btn" danger @click="showDeleteReport = true">
		<Icon class="trash-icon" name="uil-trash-alt" size="midi" />
		<span class="delete-span">Delete</span>
	</DmDropdownMenuItem>
	<CenterModal v-if="showDeleteReport" @update:show="showDeleteReport = $event">
		<div>
			<h1 class="primary-header">
				<Icon name="uil-trash-alt" size="medium" />
				<span>Delete report</span>
			</h1>
			<span class="text secondary-text"> All data related with the report will be deleted. This action cannot be undone. </span>
			<div class="actions">
				<DmButton id="cancel" class="transparent small" @click="showDeleteReport = false">Cancel</DmButton>
				<DmButton id="delete" class="danger small" @click="onDeleteReport">Delete</DmButton>
			</div>
		</div>
	</CenterModal>
</template>

<style scoped lang="less">
h1 > span {
	margin-left: @micro;
}
.center-modal-panel > div {
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: @midi;
	.actions {
		align-self: flex-end;
		display: flex;
		gap: @micro;
		margin-top: @micro;
	}
}
</style>
